app.controller("MoveSessionGroupsController", ["$scope", "$uibModalInstance", "Selection",
    function ($scope, $uibModalInstance, Selection) {

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Selection.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.move = function () {
            $uibModalInstance.close($scope.chosenSubject);
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
